export const VIEW_NAME = {
  LOGIN_SCREEN: 'login',
  ACCOUNT_RECOVERY_SCREEN: 'accountRecovery',
  EDIT_PHONE_NUMBER_SCREEN: 'editPhoneNumber',
  EMAIL_VERIFICATION_SCREEN: 'emailVerification',
  ONE_TIME_PASSCODE_SCREEN: 'oneTimePasscode',
  ONE_TIME_PASSCODE_EXPIRATION_SCREEN: 'oneTimePasscodeExpiration',
  QUICK_RESPONSE_CODE_SCREEN: 'quickResponseCode',
  VERIFICATION_SCREEN: 'verification',
  RESET_MY_PASSWORD_SCREEN: 'resetMyPassword',
  SELECT_VERIFICATION_METHOD_SCREEN: 'selectVerificationMethod',
  DELTA_APP_NOTIFICATION: 'deltaAppNotification',
  RECOVERY_PASSCODE_SCREEN: 'recoveryPasscode',
  RECOVERY_EXPIRATION_SCREEN: 'recoveryExpiration',
  SAVE_VERIFICATION_SCREEN: 'saveVerification',
  ADD_VERIFICATION_SCREEN: 'addVerification',
  REMOVE_VERIFICATION_MODAL: 'removeVerificationModal',
  MULTI_FACTOR_AUTHENTICATION_ENTRY_SCREEN: 'multiFactorAuthenticationEntry',
  EMAIL_ON_HOLD_MODAL: 'emailOnHoldModal',
  PRIMARY_VERIFICATION_MODAL: 'primaryVerificationModal'
};

export const ACCOUNT_RECOVERY_SCREEN_VIEW_NAME: string[] = [
  VIEW_NAME.RESET_MY_PASSWORD_SCREEN,
  VIEW_NAME.SELECT_VERIFICATION_METHOD_SCREEN,
  VIEW_NAME.DELTA_APP_NOTIFICATION,
  VIEW_NAME.RECOVERY_PASSCODE_SCREEN,
  VIEW_NAME.RECOVERY_EXPIRATION_SCREEN,
  VIEW_NAME.VERIFICATION_SCREEN
];

export const enum IDP_APP {
  MULTI_FACTOR_AUTHENTICATION = 'MULTI_FACTOR_AUTHENTICATION'
}

export const enum EndpointKey {
  MULTI_FACTOR_AUTHENTICATION_AEM_URL = 'MULTI_FACTOR_AUTHENTICATION_AEM_URL',
  PROFILE_GRAPHQL_ENDPOINT = 'PROFILE_GRAPHQL_ENDPOINT',
  COUNTRY_CODES = 'COUNTRY_CODES'
}

export const DEFAULT_COUNTRY_REGION_CODE = {
  id: 'placeholder',
  label: 'United States (1)',
  value: '+1'
};

export const REFRESH_URL = 'refreshURL';
export const EXIT = 'exit';
export const AEM_STATIC_EMAIL = 'xxx@delta.com';
export const AEM_DEMO_EMAIL = 'abcd12@gmail.com';
export const AEM_DEMO_PHONE = 'xxxxxxxxxx';
export const PHONE_REGEX = /\d(?=(?:\D*\d){4})/g;
export const SETUP_LATER_LABEL = 'SETUP LATER';
export const COMPLETED = 'COMPLETED';
export const MFA_COMPLETED = 'MFA_COMPLETED';
export const ERROR_MSG = 'ERROR_MSG_';
export const ERROR_MSG_DEFAULT_ERROR = 'ERROR_MSG_DEFAULT_ERROR';
export const ERROR_MSG_PUSH_CONFIRMATION_REJECTED =
  'ERROR_MSG_PUSH_CONFIRMATION_REJECTED';
export const ERROR_MSG_PUSH_CONFIRMATION_TIMED_OUT =
  'ERROR_MSG_PUSH_CONFIRMATION_TIMED_OUT';
export const ERROR_MSG_PUSH_CONFIRMATION_TIMED_OUT_PROFILE =
  'ERROR_MSG_PUSH_CONFIRMATION_TIMED_OUT_PROFILE';
export const SMS_ACTIVATION_REQUIRED = 'SMS_ACTIVATION_REQUIRED';
export const DEVICE_PAIRING_METHOD_REQUIRED = 'DEVICE_PAIRING_METHOD_REQUIRED';
export const MOBILE_ACTIVATION_REQUIRED = 'MOBILE_ACTIVATION_REQUIRED';
export const AUTHENTICATION_REQUIRED = 'AUTHENTICATION_REQUIRED';
export const OTP_REQUIRED = 'OTP_REQUIRED';
export const RESOURCE_NOT_FOUND = 'RESOURCE_NOT_FOUND';
export const ERROR_MSG_RESOURCE_NOT_FOUND = 'ERROR_MSG_RESOURCE_NOT_FOUND';
export const INVALID_ACTION_ID = 'INVALID_ACTION_ID';
export const ERROR_MSG_INVALID_ACTION_ID = 'ERROR_MSG_INVALID_ACTION_ID';
export const SERVER_ERROR = 'SERVER_ERROR';
export const OTP_RESEND_LIMIT = 'OTP_RESEND_LIMIT';
export const SERVICE_UNAVAILABLE = 'SERVICE_UNAVAILABLE';
export const VALIDATION_ERROR = 'VALIDATION_ERROR';
export const ERROR_MSG_SERVER_ERROR = 'ERROR_MSG_SERVER_ERROR';
export const ERROR_MSG_QUICK_RESPONSE_EXPIRY =
  'ERROR_MSG_QUICK_RESPONSE_EXPIRY';
export const PASSWORD_RESET_REQUIRED = 'PASSWORD_RESET_REQUIRED';
export const enum DeviceTypes {
  MOBILE = 'MOBILE',
  SMS = 'SMS',
  EMAIL = 'Email',
  REGISTER = 'REGISTER',
  Email = 'email'
}
export const MOBILE_DEVICES_TYPES = ['MOBILE', 'Android', 'iPhone'];
export const enum ONE_TIME_PASSCODES_ERROR {
  INVALID_OTP = 'ERROR_MSG_INVALID_OTP',
  OTP_ATTEMPTS_LIMIT = 'ERROR_MSG_OTP_ATTEMPTS_LIMIT',
  TOTP_ATTEMPTS_LIMIT = 'ERROR_MSG_TOTP_ATTEMPTS_LIMIT'
}
export const FLY_DELTA_VERIFIED_MESSAGE = 'Fly Delta App Verified';
export const MFA_ACCOUNT_RECOVERY_FAILED = 'ERROR_MSG_127';
export const TEXT_ME_AT =
  '<img src="/content/dam/delta-applications/aura/general/images/icons/message-icon.svg"> &nbsp&nbsp Text me at ';
export const MFA_FAILED = 'mfaFailed';
export enum ANALYTICS_EVENTS {
  EMAIL_VERIFICATION_SCREEN_LOADED = 'MFA:emailVerification:Loaded',
  ONE_TIME_PASSCODE_EMAIL_SCREEN_LOADED = 'MFA:oneTimePasscodeEmail:Loaded',
  ONE_TIME_PASSCODE_SMS_SCREEN_LOADED = 'MFA:oneTimePasscodeSms:Loaded',
  ONE_TIME_PASSCODE_EXPIRATION_EMAIL_SCREEN_LOADED = 'MFA:oneTimePasscodeExpirationEmail:Loaded',
  ONE_TIME_PASSCODE_EXPIRATION_SMS_SCREEN_LOADED = 'MFA:oneTimePasscodeExpirationSms:Loaded',
  ACCOUNT_RECOVERY_SCREEN_LOADED = 'MFA:accountRecovery:Loaded',
  EDIT_PHONE_NUMBER_SCREEN_LOADED = 'MFA:editPhoneNumber:Loaded',
  QUICK_RESPONSE_CODE_SCREEN_LOADED = 'MFA:quickResponseCode:Loaded',
  VERIFICATION_EMAIL_SCREEN_LOADED = 'MFA:verificationEmail:Loaded',
  VERIFICATION_SMS_SCREEN_LOADED = 'MFA:verificationSms:Loaded',
  VERIFICATION_FLY_DELTA_SCREEN_LOADED = 'MFA:verificationFlyDelta:Loaded',
  RESET_PASSWORD_BFF_FLOW = 'BFF:resetPasswordFlow:Loaded',
  RESET_PASSWORD_MFA_FLOW = 'MFA:resetPasswordFlow:Loaded',
  SELECT_VERIFICATION_METHOD_SCREEN_LOADED = 'MFA:resetPassword:selectVerificationMethod:Loaded',
  RECOVERY_PASSCODE_EMAIL_SCREEN_LOADED = 'MFA:resetPassword:recoveryPasscodeEmail:Loaded',
  RECOVERY_PASSCODE_SMS_SCREEN_LOADED = 'MFA:resetPassword:recoveryPasscodeSms:Loaded',
  RECOVERY_PASSCODE_TOTP_SCREEN_LOADED = 'MFA:resetPassword:recoveryPasscodeTotp:Loaded',
  DELTA_APP_NOTIFICATION_SCREEN_LOADED = 'MFA:resetPassword:deltaAppNotification:Loaded',
  RECOVERY_EXPIRATION_SCREEN = 'MFA:resetPassword:recoveryExpiration:Loaded',
  RESET_PASSWORD_VERIFICATION_EMAIL_SCREEN_LOADED = 'MFA:resetPassword:verificationEmail:Loaded',
  RESET_PASSWORD_VERIFICATION_SMS_SCREEN_LOADED = 'MFA:resetPassword:verificationSms:Loaded',
  RESET_PASSWORD_VERIFICATION_FLY_DELTA_SCREEN_LOADED = 'MFA:resetPassword:verificationFlyDelta:Loaded',
  RESET_MY_PASSWORD_SCREEN_LOADED = 'MFA:resetPassword:resetMyPassword:Loaded',
  SUCCESSFUL_PASSWORD_RESET = 'MFA:resetPassword:successfulPasswordReset:Loaded',
  RESET_PASSWORD_FLOW_ERROR = 'MFA:resetPasswordFlow:errorTriggered',
  SETUP_AFTER_LOGIN_ERROR = 'MFA:setupAfterLogin:errorTriggered',
  STANDARD_ENROLLMENT_ERROR = 'MFA:standardEnrollment:errorTriggered'
}
export const DEFAULT_TIMEOUT = 10000;
export const EXPIRE_TIMER = 600;
export const PUSH_NOTIFICATION_TIMER = 60;
export const VERIFICATION_SCREEN_TIMER = 3000;
export const DEFAULT_COOL_DOWN_TIME = 121;
export const SUCCESSFUL_PASSWORD_RESET = 'SUCCESSFUL_PASSWORD_RESET';
export const INITIATE_RESET_PASSWORD = 'INITIATE_RESET_PASSWORD';
export const SUBMIT_NEW_PASSWORD = 'SUBMIT_NEW_PASSWORD';
export const SKYMILES_LOGIN_REDIRECT_PATH = '/skymiles/login?verified=true';
export const PROFILE_SECURITY_SETTINGS_PATH = '/myprofile/security-settings';
export const INITIATE_DEVICE_METHOD = 'INITIATE_DEVICE_METHOD';
export const INITIATE_FLY_DELTA_POLL = 'INITIATE_FLY_DELTA_POLL';
export const SELECT_DEVICE_METHOD = 'SELECT_DEVICE_METHOD';
export const ERROR_MSG_INVALID_PHONE = 'ERROR_MSG_INVALID_PHONE';
export const SUBMIT_OTP = 'SUBMIT_OTP';
export const SKYMILES_RESET_PASSWORD_REDIRECT_PATH =
  '/skymiles/resetPassword?mfaFailed=true';
export const REMAINING_ATTEMPT = 5;
